import { ChangeDetectorRef, EventEmitter, Output } from "@angular/core";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormArray, FormBuilder, FormControl } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { UserService } from "../service/user.service";
import { Log } from "../util/log";
import { Overlay } from '@angular/cdk/overlay';
import { ActivationCode } from "../model/activationCode";
import { DateHelper } from "../util/dateHelper";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { CodeDescriptionDialogComponent } from "../code-description-dialog/code-description-dialog.component";

@Component({
  selector: 'app-code-list-editor',
  templateUrl: './code-list-editor.component.html',
  styleUrls: ['./code-list-editor.component.css']
})
export class CodeListEditorComponent implements OnInit {

  @ViewChild("activationcodeloader", { static: true }) loader;

  codes: ActivationCode[] = [];
  activationCodesForm: FormGroup;
  items: FormArray = new FormArray([]);
  userOwnerId: string;

  notActivatedString: string = $localize`:@code_list_editor_not_activated: Non attivato`

  constructor(
    public dialogRef: MatDialogRef<CodeListEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private overlay: Overlay
  ) {
    this.userOwnerId = data.userOwnerId;

    // creo una copia per non modificare l'originale
    for (let activationCode of data.codeListData) {
      this.codes.push(activationCode);
    }

    for (let activationCode of this.codes) {
      this.items.push(this.createItem(activationCode));
    }

    this.activationCodesForm = this.formBuilder.group({
      items: this.items
    });
  }

  ngOnInit(): void { }

  ngAfterViewInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

  createItem(activationCode: ActivationCode): FormGroup {
    let itemDate: string;
    if (activationCode.activatedAt) {
      itemDate = DateHelper.formatDateFriendly(activationCode.activatedAt);
    } else {
      itemDate = this.notActivatedString;
    }
    Log.debug("itemDate: " + itemDate);
    return new FormGroup({
      code: new FormControl(activationCode.code),
      description: new FormControl(activationCode.description),
      date: new FormControl(itemDate)
    });
  }

  createNewCode(): void {

    let newCode: string;

    Log.debug("clicked createNewCode ");

    this.userService.postActivationCode(this.userOwnerId).subscribe((response) => {
      newCode = response.code;
      this.items.controls.push(new FormGroup({
        code: new FormControl(newCode),
        date: new FormControl(this.notActivatedString)
      }));
    }, (err) => {
      Log.debug(err);
      this.loader.showError();
    });
  }

  deleteItem(i: number): void {


    let message = $localize`:@@odelisteditor_delete_code_confirm}: Conferma eliminazione codice`;
    let confirmMessage = $localize`:@@odelisteditor_delete_code_confirm_yes}: Conferma`;
    let cancelMessage = $localize`:@@odelisteditor_delete_code_confirm_no}: Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {

      Log.debug(response);
      if (response) {
        this.userService.deleteActivationCode(this.userOwnerId, this.items.controls[i].value.code).subscribe((response) => {
          this.items.controls.splice(i, 1);
        }, (err) => {
          Log.debug(err);
          this.loader.showError();
        });
      }
    });
  }


  editItem(i: number): void {
    Log.debug(this.items.controls[i].value);
    Log.debug(this.items.controls[i].value.description);

    let currentDescription = this.items.controls[i].value.description;
    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(CodeDescriptionDialogComponent, {
      width: "600px",
      data: { currentDescription },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      Log.debug(response);
      if (response) {
        this.items.controls[i].value.description = response;
        this.userService.putActivationCode(this.userOwnerId, this.items.controls[i].value).subscribe((response) => {
          Log.debug(response);
        }, (err) => {
          Log.debug(err);
          this.loader.showError();
        });

      }
    });
  }

}


